
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_9304wGS0u_45mdCofC_452XPnPTMYOv6M2d5u5y1_VY6KGD_8Meta } from "/codebuild/output/src783351460/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasc7_45HOgYuywOW5TavBsI6ytOPmavGegt9yWFEoKeWfMAMeta } from "/codebuild/output/src783351460/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexYEZcMEEzRa46Krv7eQdFhPfrjqyPI3qkDzVGbrBVSV4Meta } from "/codebuild/output/src783351460/src/ark/pages/blog/index.vue?macro=true";
import { default as temasOslsyjJQGdNlpfzl6mhPhOdakoRGzsP96ajV_45_wyT0gMeta } from "/codebuild/output/src783351460/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisakBWt_455IFrH2eW8vS0J8mUltb_CF3_vGCGcHskGC5dq8Meta } from "/codebuild/output/src783351460/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradacnnDPLRGz7A0xI5rWtLagFxAoNHizd14maYnBfh2AkMMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesbH2sbUKVvRc_45XSFYCIrQERRgImnIIDDFE50_45jlGZcb8Meta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gas0edBeFmNeukTMAfKeAL8zXaHGTmTCv7vWM_45yeMojLm4Meta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casahvxcjfFbncTqclHo_FrhGfNfY_452HhtbcOJZG3ToQIzgMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produto6QvBihrGTOAYB2h5E0hDPyx9D5IQ3bXrTWISKEkgUZsMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadorauv255fW88p3V7qg2_V3mXzRUO53iOt9zgcT253gu34IMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoOLWfIMBN6KWbN_45pOV0Istyxs_P7k5vOhwo0nLQnXVCEMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaCcZ7x3DWSbIX8KqOaMNROZ_45KUmz_NGxtgROgwSwiRvEMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularDqn4W1nXtSASQcu089fijYoTUMZV0l3rf_45kcK5YQiuoMeta } from "/codebuild/output/src783351460/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetlXo4f65R9ZlShnLHPHf1rgRbNhyyqRbnwjKYd445J2AMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovel3PKJ0gkpPEjDY4zkTqa19yJyD7wZEykEPHqVgSGXZXgMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoZQ9nJpAv9NROmqordIOIPD2QHL9rNvdOOfv3eUdS9qcMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualSsXq8LrGqIIUKcfe_BpokmBIMe6_45U7UmwcBjD3AwbQkMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactogTKnKedg6UIMCIAxneiTyw6zmxBIJf11J7FOsUCXAnAMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularANZALBEi_LYsBj_45cP2IYqpLD7tt1_c5EQT6WDs_45ZfmQMeta } from "/codebuild/output/src783351460/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93x_w5PzL_o7zlDW_45oQbxn2JNgFfPDn4SO_l9uimyUixQMeta } from "/codebuild/output/src783351460/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93lCWMKMnTCf_ilA5RCA_YP235TsykmfCoXnRgJaiBUQkMeta } from "/codebuild/output/src783351460/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoNijj4GHgyC8zGO7Yd5W_45YXYUFESoOKq2J45YBfS7JlsMeta } from "/codebuild/output/src783351460/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadetGnLomrvKg0N7etPQ_ML96CX6zdm0w3aXrcO7BWe7GcMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxaltCcWSNORNPYMuRCtChfMl_45L3unjfvaQrf0jjqSaIm8Meta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactozcVCYgHgjTw2fsakx7UCJaFyRdV3gi4lOYfuEw5Cj9wMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoOm_45PxPBUebDB4xBTUrQPqFtrNvXXS5X4xaz0DIowtjcMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiraT0vsAznVCXjtuhbqYmXD7PDG1byxMQefow6ErWH5mG4Meta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimouRqleccjHlhlZocd1_byr2JtlP5bf9mM7G2jdDtjF1IMeta } from "/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularFLJ5HbQg_45ozsdTEgtr3yCRAXsUVZmqiFpKxXUM8W_nIMeta } from "/codebuild/output/src783351460/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93jTAiFt4Q5_U8QrgqmxWX39FNH8JiuNFVwIMNIGfWij8Meta } from "/codebuild/output/src783351460/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosDnKPl25qG_OBHUQNzX_458zKyQwd2E2FISKxVb1ugacRAMeta } from "/codebuild/output/src783351460/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexqfDeXEBOvI842ZM42cjs2LM111rt_4533iiF4he61XD64Meta } from "/codebuild/output/src783351460/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93DyArtUr5wpI5HzoVxvrp3Jkmaj_455DZ8ltfj5PgGIvIMMeta } from "/codebuild/output/src783351460/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93orX08bgF6mIhelMGTzTfmdqSAEJW1k385C2foCbvjvYMeta } from "/codebuild/output/src783351460/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: simularDqn4W1nXtSASQcu089fijYoTUMZV0l3rf_45kcK5YQiuoMeta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: simularANZALBEi_LYsBj_45cP2IYqpLD7tt1_c5EQT6WDs_45ZfmQMeta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: simularFLJ5HbQg_45ozsdTEgtr3yCRAXsUVZmqiFpKxXUM8W_nIMeta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src783351460/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93jTAiFt4Q5_U8QrgqmxWX39FNH8JiuNFVwIMNIGfWij8Meta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosDnKPl25qG_OBHUQNzX_458zKyQwd2E2FISKxVb1ugacRAMeta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src783351460/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93DyArtUr5wpI5HzoVxvrp3Jkmaj_455DZ8ltfj5PgGIvIMMeta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93orX08bgF6mIhelMGTzTfmdqSAEJW1k385C2foCbvjvYMeta || {},
    component: () => import("/codebuild/output/src783351460/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]